<template>
	<HeaderBlock title="Personal Information" />
	<CustomerLoadWait :customer="customer" />
	<transition>
		<div v-if="customer" class="personal-info-page">

			<!-- About me -->
			<div class="pi-section">
				<div class="pi-section-title">About me</div>
				<InputSections ref="inputSections" :sections="sections" theme="light" />
			</div>

			<!-- Contact details -->
			<div class="pi-section">
				<div class="pi-section-title">Contact details</div>
				<div class="pi-locked-card">
					<div class="pi-locked-row">
						<span class="pi-label">Email</span>
						<span class="pi-value">{{ customer.person.email }}</span>
					</div>
					<img src="@/assets/lock.svg" alt="" class="pi-lock-icon" />
				</div>
				<div class="pi-locked-card">
					<div class="pi-locked-row">
						<span class="pi-label">Mobile no.</span>
						<span class="pi-value">{{ customer.person.mobilePhone }}</span>
					</div>
					<img src="@/assets/lock.svg" alt="" class="pi-lock-icon" />
				</div>
				<div class="pi-help-text" @click="$refs.contactDrawer.openDrawer()">Something not right? Request to update</div>
			</div>

			<!-- Update button -->
			<MGButton text="Update" :disabled="!hasChanges" @click="updateDetails" :fullWidth="true" />

		</div>
	</transition>

	<DrawerPanel
		ref="contactDrawer"
		:close="true"
		:divider="false"
		:openHeight="'50%'"
		:blurBackground="true"
		bottom="-95px"
		closedHeight="0px"
		backgroundColor="transparent"
		openBackgroundColor="#fff"
	>
		<div class="contact-drawer-content">
			<div class="contact-drawer-title">Something not right?</div>
			<div class="contact-drawer-description">If you need to update your mobile phone number, let us know and we will sort it for you.</div>
			<div class="contact-drawer-email">help@moneyguided.com</div>
			<MGButton text="Get in touch" :arrow="true" @click="openMailto" />
		</div>
	</DrawerPanel>
</template>

<script>
import Services from '../mixins/Services';
import Helpers from '../mixins/Helpers';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
import DrawerPanel from './elements/DrawerPanel.vue';

export default {
	name: 'PersonalInformationPage',
	mixins: [Services, Helpers],
	components: { CustomerLoadWait, HeaderBlock, InputSections, MGButton, DrawerPanel },
	data() {
		return {
			sections: [],
			originalValues: {},
		}
	},
	computed: {
		// postcode() {
		// 	if (this.customer?.person?.addresses?.length > 0) {
		// 		return this.customer.person.addresses[0].postCode || '';
		// 	}
		// 	return '';
		// },
		hasChanges() {
			if (!this.sections.length || !this.sections[0]?.fields) return false;
			return this.sections[0].fields.some(f => f.value !== this.originalValues[f.label]);
		}
	},
	methods: {
		onLoad() {
			this._getCustomer(() => {
				this.sections = [{
					fields: [
						{ label: 'First name', type: 'text', value: this.customer.person.firstName || '', required: true, validationText: 'Please enter your first name' },
						{ label: 'Last name', type: 'text', value: this.customer.person.lastName || '', required: true, validationText: 'Please enter your last name' },
						// { label: 'Postcode', type: 'text', value: this.postcode, required: true, validationText: 'Please enter your postcode' },
					]
				}];
				this.originalValues = {
					'First name': this.customer.person.firstName || '',
					'Last name': this.customer.person.lastName || '',
					// 'Postcode': this.postcode,
				};
			});
		},
		openMailto() {
			window.location.href = 'mailto:help@moneyguided.com';
		},
		updateDetails() {
			const updateRequest = {
				firstName: this._findFieldValue('First name'),
				lastName: this._findFieldValue('Last name'),
				// postCode: this._findFieldValue('Postcode'),
			};
			this._updateCustomerDetails(updateRequest, () => {
				this._getCustomer(null, false);
				this.$router.push('/settings');
			});
		}
	},
	mounted() {
		this.onLoad();
	}
}
</script>

<style scoped>
.personal-info-page {
	display: flex;
	flex-direction: column;
	gap: 32px;
	padding-bottom: 32px;
}

.pi-section {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.pi-section-title {
	font-size: 15px;
	font-weight: bold;
	color: var(--text-color);
	margin-bottom: 8px;
}

.pi-locked-card {
	display: flex;
	align-items: center;
	gap: 4px;
	background: rgba(255, 255, 255, 0.9);
	border-radius: 8px;
	padding: 16px;
}

.pi-locked-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex: 1;
}

.pi-label {
	font-size: 13px;
	color: var(--text-color);
}

.pi-value {
	font-size: 13px;
	color: var(--text-color);
}

.pi-lock-icon {
	width: 12px;
	height: 12px;
}

.pi-help-text {
	font-size: 13px;
	line-height: 1.54;
	color: var(--text-color);
}

:deep(.inputSections) {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

:deep(.inputSections .v-input) {
	margin-bottom: 0;
}

:deep(.inputSections .v-field) {
	border-radius: 6px;
}

.contact-drawer-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	text-align: center;
}

.contact-drawer-title {
	font-size: 18px;
	font-weight: bold;
	color: var(--text-color);
}

.contact-drawer-description {
	font-size: 13px;
	line-height: 1.23;
	color: var(--text-color);
}

.contact-drawer-email {
	font-size: 15px;
	font-weight: bold;
	color: var(--text-color);
}
</style>
